/* eslint-disable */
import {
  axios,
  config
} from '../api'
// import store from '../store'

let user = {}

user.login = (_phone, _password) => {
  return axios('post', config.API_URL + '/api/SysUser/login', {
    phone: _phone,
    password: _password
  })
}

user.logout = () => {
  return axios('post', config.API_URL + '/api/SysUser/logout', {})
}

user.editPassword = {
  data: {
    oldPass: '',
    newPass: '',
    newPassConfirm: ''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/SysUser/EditPassword', _data)
  }
}

export default user


